


































































































































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import { UserTermsType } from "@/shared/types";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import HsaBankFeeScheduleAndInterestRatesInfo from "@/employee/components/shared/HsaBankFeeScheduleAndInterestRatesInfo.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserStore } from "@/shared/store/user";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useWizardStore } from "@/employee/store/wizard";
import { useNotificationPreferencesStore } from "@/shared/store/notificationPreferences";
import { openExternalUrl } from "@/shared/urlHelper";
import { isProd } from "@/shared/env";

@Component({
  components: {
    Checkbox,
    Button,
    HsaBankFeeScheduleAndInterestRatesInfo
  }
})
export default class Terms extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();
  enrollmentStore = useEnrollmentStore();
  portalCustomizationStore = usePortalCustomizationStore();
  featureFlagStore = useFeatureFlagStore();
  wizardStore = useWizardStore();
  notificationPreferencesStore = useNotificationPreferencesStore();

  isSubmitting = false;
  isLoaded = true;
  agreedToESignTerms = false;
  agreedToTerms = false;
  agreedToPaperlessCommunications = false;
  showPaperlessCommunicationsCheckBox = false;
  isFeeModalOpen = false;

  @Prop({ default: true })
  showHsaTerms: boolean;

  @Prop({ required: true })
  termsType: UserTermsType;

  @Prop({ default: true })
  showFeeSchedule: boolean;

  @Prop()
  onBack: (hasUnsavedChanges: boolean) => void;

  mounted () {
    this.enrollmentStore.loadFeeWaiverSettings(this.userStore.partnerId);

    if (this.featureFlagStore.flags.bend25434EnableNotificationPreferences && this.isInModal) {
      this.notificationPreferencesStore.getNotificationPreferences();
    }

    if (this.isInWizard && this.wizardStore.isStepComplete("terms-and-conditions")) {
      this.agreedToESignTerms = true;
      this.agreedToTerms = true;
    }
  }

  @Watch("notificationPreferencesStore.notificationPreferencesLoaded", {immediate: true})
  onNotificationPreferencesLoaded () {
    if (!this.featureFlagStore.flags.bend29187ShowPaperlessCheckboxInTerms) {
      return;
    }

    if (this.notificationPreferencesStore.notificationPreferencesLoaded) {
      if (this.featureFlagStore.flags.bend25434EnableNotificationPreferences &&
          this.notificationPreferencesStore.HasAnyPaperPreferencesOn &&
          this.isInModal) {
        this.showPaperlessCommunicationsCheckBox = true;
        this.agreedToPaperlessCommunications = true;
      }
    }
  }

  get termsBaseurl (): string {
    if (isProd()) {
      return "https://account.hsabank.com";
    }

    return "https://hive-uat.hsabank.com";
  }

  get termsUrl (): string {
    return this.custodianSettingsStore.termsUrl;
  }

  get hsaTermsUrl (): string {
    return this.custodianSettingsStore.hsaTermsUrl;
  }

  get termsExternalUrl (): string {
    return `${this.termsBaseurl}${this.termsUrl}`;
  }

  get hsaTermsExternalUrl (): string {
    return `${this.termsBaseurl}${this.hsaTermsUrl}`;
  }

  get submitDisabled () {
    return !this.agreedToESignTerms || !this.agreedToTerms || this.isSubmitting;
  }

  get isInWizard () {
    return this.termsType === UserTermsType.Wizard;
  }

  get isInModal () {
    return this.termsType === UserTermsType.Prompt;
  }

  get eSignatureAgreedTo () {
    return "inline-content-esign-disclosure-as-of-2021-07-13";
  }

  onSubmit (): void {
    if (this.isSubmitting) {
      return;
    }

    if (!this.agreedToESignTerms || !this.agreedToTerms) {
      return;
    }

    this.isSubmitting = true;
    this.enrollmentStore.saveAgreedToTerms(this.eSignatureAgreedTo, this.termsType)
        .then(() => this.enrollmentStore.saveAgreedToTerms(this.termsUrl, this.termsType))
        .then(() => {
          if (this.showHsaTerms) {
            this.enrollmentStore.saveAgreedToTerms(this.hsaTermsUrl, this.termsType);
          }
        })
        .then(() => {
          const result = this.enrollmentStore.saveAgreedToFeeTerms();

          if (this.termsType === UserTermsType.Wizard) {
            return this.enrollmentStore.termsAccepted();
          }
          return result;
        })
        .then(async () => {
          if (this.agreedToPaperlessCommunications) {
            await this.notificationPreferencesStore.savePaperlessNotificationPreferences();
          }
        })
        .then(() => this.$emit("complete"))
        .finally(() => this.isSubmitting = false);
  }

  goBack () {
    if (this.onBack) {
      this.onBack(false);
    }
  }

  onShowFeeModalClicked () {
    this.isFeeModalOpen = true;
  }

  open (url: string) {
    openExternalUrl(url);
  }
}
